import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const TotalRow = ({ date, days, actuals, showWeekendLogs, visibleDayIndexes }) => {
  const { t } = useTranslation();
  const [totalValues, setTotalValues] = useState([]);

  useEffect(() => {
    setTotalValues(
      visibleDayIndexes.map((index) => {
        const day = date.plus({ days: index });
        const totalDuration = actuals
          .filter((actual) => actual.date === day.toFormat("yyyy-MM-dd"))
          .reduce((acc, actual) => acc + actual.duration, 0);
        return formattedDuration(totalDuration);
      })
    );
  }, [days, actuals, showWeekendLogs, date, visibleDayIndexes]);

  const formattedDuration = (duration) => {
    if (duration === 0) {
      return 0;
    }
    return `${Math.floor(duration / 60)}.${duration < 10 ? "0" : ""}${((duration % 60) / 60) * 100}`;
  };

  return (
    <div className="actuals__by-project__totals-row">
      <div className="actuals__by-project__totals-row__spacer">
        <p>{t("dashboard.total")}</p>
      </div>
      <div className="actuals__by-project__totals-row__days">
        {visibleDayIndexes.map((index) => {
          const day = date.plus({ days: index });
          const isWeekend = [6, 7].includes(day.weekday);

          return (
            <>
              <div
                key={`day-${index}`}
                className={`actuals__by-project__totals-row__day ${index === 0 ? "first-column" : ""} ${
                  isWeekend ? "weekend" : ""
                }`}
                data-isweekend={isWeekend}
              >
                <p className="actuals__by-project__totals-row__day-text" id={`total-text-${index}`}>
                  {totalValues[visibleDayIndexes.indexOf(index)]}h
                </p>
              </div>

              {
                day.weekday === 5 && !showWeekendLogs && (
                  <div className="actuals__by-project__hidden-weekends"/>
                )
              }
            </>
          );
        })}
      </div>
    </div>
  );
};

TotalRow.propTypes = {
  date: PropTypes.shape({
    plus: PropTypes.func.isRequired,
    toFormat: PropTypes.func.isRequired,
  }).isRequired,
  days: PropTypes.number.isRequired,
  actuals: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      duration: PropTypes.number.isRequired,
    })
  ).isRequired,
  showWeekendLogs: PropTypes.bool,
  visibleDayIndexes: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default TotalRow;
